import { createSlice } from "@reduxjs/toolkit";
import {
  auth,
  getUserDetails,
  storeUser,
  getUser,
  removeUser,
  projects,
} from "../../api/authentication/auth";

import { hash } from "../../common/utils/crypto";

import { getLocalStorage, setLocalStorage } from "../../common/utils/utils";

const expireTime = process.env.REACT_APP_AUTH_EXPIRATION_MINUTES;

const proj = getLocalStorage('selectedProject');

console.log('proj: %o', proj);

export const authenticationSlice = createSlice({
  name: "authentication",
  initialState: {
    user: null,
    loader: null,
    loginError: null,
    userDetails: null,
    selectedProject: null,
  },
  reducers: {
    setUserDetails: (state, action) => {
      state.userDetails = action.payload;
    },

    setUser: (state, action) => {
      state.user = action.payload;
    },

    setLoader: (state, action) => {
      state.loader = action.payload;
    },

    setLoginError: (state, action) => {
      state.loginError = action.payload;
    },

    setSelectedProject: (state, action) => {
      console.log('set proj: %o', action.payload);
      setLocalStorage('selectedProject', action.payload);
      state.selectedProject = action.payload;
    },
  },
});

export const {
  setUserDetails,
  setUser,
  setLoader,
  setLoginError,
  setSelectedProject,
} = authenticationSlice.actions;

const _login = async (dispatch, username, password) => {
  try {
    let loginSuccess = await auth(username, password);
    console.log("loginSuccess: %o", loginSuccess);
    if (loginSuccess) {
      dispatch(setUser({ username, password }));
      let userDetails = await getUserDetails(username, password);
      dispatch(setUserDetails(userDetails));
      const proj = getLocalStorage('selectedProject');
      if (proj) {
        dispatch(setSelectedProject(proj));
      }
      else {
        let project = projects.find(item => item.id === userDetails.projects[0].id);
        dispatch(setSelectedProject(project));
      }
      storeUser({ username, password, timestamp: new Date().getTime() });
    } else {
      dispatch(setLoginError("FAILED_LOGIN"));
    }
  } catch (err) {
    dispatch(setLoginError("FAILED_CONNECTION"));
  }
};

export const login = (username, password) => async (dispatch) => {
  dispatch(setLoader("LOGIN"));
  password = hash(password);
  await _login(dispatch, username, password);
  dispatch(setLoader(null));
};

export const refreshSession = () => async (dispatch) => {
  dispatch(setLoader("REFRESH_SESSION"));
  const user = getUser();
  if (user?.username && user?.password && user?.timestamp) {
    const { username, password } = user;
    if (new Date().getTime() - user.timestamp < 1000 * 60 * expireTime) {
      dispatch(setUser({ username, password }));
      let userDetails = await getUserDetails(username, password);
      dispatch(setUserDetails(userDetails));
    } else {
      await _login(dispatch, username, password);
    }
  }
  dispatch(setLoader(null));
};

export const logout = () => async (dispatch) => {
  dispatch(setUser(null));
  dispatch(setUserDetails(null));
  removeUser();
};

export const selectProject = (projectId) => async (dispatch) => {
  let project = projects.find(item => item.id === projectId);
  dispatch(setSelectedProject(project));
};

export const selectUser = (state) => state.authentication.user;
export const selectUserDetails = (state) => state.authentication.userDetails;
export const selectSelectedProject = (state) => state.authentication.selectedProject;
export const selectLoader = (state) => state.authentication.loader;
export const selectError = (state) => state.authentication.loginError;

export default authenticationSlice.reducer;
